module.exports = __webpack_public_path__ + "img/eComm-img.06913799.png";